import { CoordinatorService } from './coordinator.service';
import { Story } from './story';
import { StoryItem } from './story-item';
import { XItem } from './x-item';

export class Img {
    id: string;
    private _title?: string | undefined;

    source?: XItem;
    data?: string;
    mimetype?: string;
    parent: Story;

    notepadItemIdLs = []; // dummy for some processing of StoryItem

    private _isEditMode = false;

    constructor(
        private coords: CoordinatorService,
        {
            id,
            parent,
            data,
            mimetype,
            title,
        }: {
            parent: Story;
            id?: string;
            data?: string;
            mimetype?: string;
            title?: string;
            onUpdate?: (params: any) => void;
        },
    ) {
        this.id = id || this.coords.uniqueId();
        this.parent = parent;
        this.data = data;
        this.mimetype = mimetype;
        this._title = title || '';
    }

    public get title(): string | undefined {
        return this._title;
    }
    public set title(value: string | undefined) {
        this._title = value;
    }

    delete() {
        this.parent.deleteItem(this);
    }

    edit(params?: { isNew?: boolean; position?: number }) {
        this.coords.display$.dialog$.next({
            action: 'edit-image',
            img: this,
            insertParams: params,
        });
    }

    get isEditMode() {
        return this._isEditMode;
    }

    set isEditMode(value: boolean) {
        this._isEditMode = value;
        value && this.edit();
        this.coords.display$.markForCheck();
    }

    insert(isBefore: boolean, kind = 'story-item') {
        return this.parent.addItem(this, isBefore, kind);
    }

    move(isUp: boolean) {
        return this.parent.moveItem(this, isUp);
    }

    get isReady() {
        return !!this.data;
    }

    async load() {
        const resp = await this.coords.filesystem$.pickFileToDataURL();
        if (!resp || !resp.data) {
            this.coords.display$.closeDialog();
            return;
        }

        this.mimetype = resp.type;

        this.data = resp.data;
        this.coords.display$.markForCheck();
    }

    update(params?: any) {
        if (params?.isNew) {
            this.parent.finalizeAddItem(this, params.position);
        }
        this.parent.markForManifestStore();
        this.coords.display$.markForCheck();
    }

    save() {
        return {
            id: this.id,
            title: this._title,
            source: this.source && this.source.id,
            data: this.data,
            mimetype: this.mimetype,
        };
    }
}
